import { forwardRef } from 'react';
import type { AnchorHTMLAttributes } from 'react';
import { styled } from 'goober';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  color?: string;
};

const Anchor = styled('a')<{ color?: string }>`
  ${({ theme }) => theme.typography.widget.smallText}
  color: ${({ theme, color }) => color ?? theme.colors.blue.primaryA};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const HrefLink = forwardRef<HTMLAnchorElement, Props>(function HrefLink(
  { color, rel = 'noopener noreferrer', target = '_blank', ...props },
  ref,
) {
  return (
    <Anchor color={color} ref={ref} rel={rel} target={target} {...props} />
  );
});
